// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2o4Nc","vLegacy":"SelectSecondary_vLegacy__2y-sN","error":"SelectSecondary_error__3Dzzg","disabled":"SelectSecondary_disabled__gU5as"};